import amenityStore from './Amenity/amenityStore';
import authStore from './authStore';
import bookingStore from './bookingStore';
import bookTaxiStore from './BookTaxi/bookTaxiStore';
import chatIntentStore from './chatIntentStore';
import chatStore from './chatStore';
import cleanRoomStore from './CleanRoom/cleanRoomStore';
import commonStore from './commonStore';
import conciergeStore from './Concierge/conciergeStore';
import dashboardStore from './dashboardStore';
import defectReportStore from './DefectReport/defectReportStore';
import dndStore from './Dnd/dndStore';
import fnbStore from './Fnb/fnbStore';
import frontOfficeStore from './FrontOffice/frontOfficeStore';
import generalSettingStore from './generalSettingStore';
import guideDocumentStore from './guideDocumentStore';
import homeRetailOfferStore from './Home/homeRetailOfferStore';
import homeSpaOfferStore from './Home/homeSpaOfferStore';
import homeSpecialOfferStore from './Home/homeSpecialOfferStore';
import hotelTvChannelStore from './hotelTvChannelStore';
import housekeepingOptInStore from './housekeepingOptInStore';
import housekeepingLinenChangeStore from './housekeepingLinenChangeStore'
import itemStore from './itemStore';
import itemTreeStore from './itemTreeStore';
import lateCheckoutStore from './LateCheckout/lateCheckoutStore';
import laundryStore from './Laundry/laundryStore';
import loginStore from './GuestLogin/loginStore';
import orderSetupStore from './orderSetupStore';
import orderStore from './Order/orderStore';
import printFileStore from './printFileStore';
import promotionStore from './promotionStore';
import recommendationStore from './recommendationStore';
import retailOfferStore from './retailOfferStore';
import shoppingStore from './Shopping/shoppingStore';
import spaStore from './Spa/spaStore';
import specialOfferStore from './specialOfferStore';
import stockStore from './stockStore';
import translationStore from './translationStore';
import viewStore from './viewStore';
import wakeUpCallStore from './WakeUpCall/wakeUpCallStore';
import weatherStore from './weatherStore';
import FnbAdditionalItemStore from './FnbAdditionalItemStore';
import importItemLanguageStore from './importItemLanguageStore';
import CmsLanguageStore from './CMS/CmsLanguageStore';
import CmsMenuStore from './CMS/CmsMenuStore';
import CmsTaskStore from './CMS/CmsTaskStore';
import webSettingStore from './webSettingStore';
import CmsClimateStore from './CMS/CmsClimateStore';
import SingleListStore from './Modules/SingleListStore';
import TransactionStore from './Modules/TransactionStore';
import CmsPaymentTypeStore from './CMS/CmsPaymentTypeStore';
import CmsTransportationTypeStore from './CMS/CmsTransportationTypeStore';
import BookingItemStore from './BookingItemStore';
import bookingSummaryStore from './Booking/bookingSummaryStore';
import BookingSubCategoryStore from './BookingSubCategoryStore';
import BookingCategoryStore from './BookingCategoryStore';
import BookingTransactionStore from './BookingTransactionStore';
import AuditLogStore from './AuditLogStore';
import popupStore from './popupStore.js';
import templateStore from './templateStore.js';
import CmsLaundryServiceStore from './CMS/CmsLaundryServiceStore';
import CmsLaundryDeliveryStore from './CMS/CmsLaundryDeliveryStore';
import VersionStore from './VersionStore';
import outOfStockRecipientStore from './outOfStockRecipientStore';
import CmsHotelDescStore from './CMS/CmsHotelDescStore';
import CmsFacilityHotelStore from './CMS/CmsFacilityHotelStore';
import CmsEventHotelStore from './CMS/CmsEventHotelStore';
import CmsSidebarStore from './CMS/CmsSidebarStore';
import CmsDiningStore from './CMS/CmsDiningStore';
import CmsDevaranaStore from './CMS/CmsDevaranaStore';
import CmsExperienceStore from './CMS/CmsExperienceStore';
import ItemRoomTypeStore from './ItemRoomTypeStore';
import RoomSetupStore from './RoomSetupStore';
import RoomTypeStore from './RoomTypeStore';
import CmsDailyActStore from './CMS/CmsDailyActStore';
import CmsDiveCenterStore from './CMS/CmsDiveCenterStore';
import spaOfferStore from './spaOfferStore';
import CmsPaymentStore from './CMS/CmsPaymentStore';
import PaymentLogStore from './PaymentLogStore';
import GuestLoginLogStore from './GuestLoginLogStore';

const stores = {
   amenityStore,
   authStore,
   bookingStore,
   bookTaxiStore,
   chatIntentStore,
   chatStore,
   cleanRoomStore,
   commonStore,
   conciergeStore,
   dashboardStore,
   defectReportStore,
   dndStore,
   fnbStore,
   frontOfficeStore,
   generalSettingStore,
   guideDocumentStore,
   homeRetailOfferStore,
   homeSpaOfferStore,
   homeSpecialOfferStore,
   hotelTvChannelStore,
   housekeepingOptInStore,
   housekeepingLinenChangeStore,
   itemTreeStore,
   itemStore,
   lateCheckoutStore,
   laundryStore,
   loginStore,
   orderSetupStore,
   orderStore,
   printFileStore,
   promotionStore,
   recommendationStore,
   retailOfferStore,
   shoppingStore,
   spaStore,
   specialOfferStore,
   stockStore,
   translationStore,
   viewStore,
   wakeUpCallStore,
   weatherStore,
   FnbAdditionalItemStore,
   importItemLanguageStore,
   CmsLanguageStore,
   CmsMenuStore,
   CmsTaskStore,
   webSettingStore,
   CmsClimateStore,
   SingleListStore,
   TransactionStore,
   CmsPaymentTypeStore,
   CmsTransportationTypeStore,
   BookingItemStore,
   bookingSummaryStore,
   BookingSubCategoryStore,
   BookingCategoryStore,
   BookingTransactionStore,
   AuditLogStore,
   popupStore,
   templateStore,
   CmsLaundryServiceStore,
   CmsLaundryDeliveryStore,
   VersionStore,
   outOfStockRecipientStore,
   CmsHotelDescStore,
   CmsFacilityHotelStore,
   CmsEventHotelStore,
   CmsSidebarStore,
   CmsDiningStore,
   CmsDevaranaStore,
   CmsExperienceStore,
   ItemRoomTypeStore,
   RoomSetupStore,
   RoomTypeStore,
   CmsDailyActStore,
   CmsDiveCenterStore,
   spaOfferStore,
   CmsPaymentStore,
   PaymentLogStore,
   GuestLoginLogStore
}

export default stores;
